// ----------------------------------------------------------------------------
// Nombre del Programa : Configuraciones
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de las configuraciones generales
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Se modificaron etiquetas 20/AGO/2024
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './Configuraciones.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileUploader } from 'react-drag-drop-files';
import { StatusAlertService } from 'react-status-alert';
import { ConfiguracionProps } from '../../interfaces/enlacesInterfaces';
import { getConfiguraciones, postConfiguracion } from '../../Services/EnlacesService';
import { postAdjunto } from '../../Services/AdjuntosService';
import { getImgMB } from '../../Utilidades/session';

export const Configuraciones = () => {
    const fileTypes = ['JPG', 'JPEG', 'PNG', 'GIF'];
    const [tituloAdjunto, setTituloAdjunto] = useState(
        'Seleccione/Arrastre Imagen'
    );
    const [urlImagen, setUrlImagen] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [configuracion, setConfiguracion] = useState<ConfiguracionProps>();

    useEffect(() => {
        cargaConfiguraciones();
    }, []);


    const cargaConfiguraciones = async () => {
        const response: any = await getConfiguraciones().catch(() => {
            setUrlImagen("")
        });
        if (response.data && response.data.data) {
            setUrlImagen(response.data.data[0].urladjunto);
            setConfiguracion(response.data.data[0])
        }
    };

    const guardarEnlace = async () => {

        if (urlImagen === '') {
            StatusAlertService.showError('Agregue la imagen');
            return;
        }

        const configuracionGuardar: ConfiguracionProps[] = [];

        configuracion!.urladjunto = urlImagen;

        configuracionGuardar.push(configuracion!);

        const response: any = await postConfiguracion(configuracion!).catch(({ response }) => {
            const { data } = response;
            StatusAlertService.showError(data.meta.message);
        });
        if (response.data && response.data.data) {
            //navigate(-1);
            StatusAlertService.showSuccess('Guardado Exitosamente');
        }
    };

    const guardarImagen = async (file: any) => {
        //setCargado(false);
        let formData = new FormData();
        formData.append('file', file);
        const response: any = await postAdjunto(formData).catch(({ response }) => {
            const { data } = response;
            StatusAlertService.showError(data.meta.message);
        });
        if (response.data) {
            //console.log('data:', response.data);
            let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
            setUrlImagen(downloadUri);
        }
    };

    const handleChangeImagen = (file: any) => {
        //setFile(file);
        setTituloAdjunto('Seleccionar/Arrastrar Otra');
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            //console.log('Result: ', reader.result);
            guardarImagen(file);
            //setImagenCargada(reader.result! as string)
        };
        reader.onerror = function (error) {
            setUrlImagen('');
            StatusAlertService.showError('Ocurrio un error al cargar el archivo...');
        };
        //console.log('file:', file);
    };
    const onSizeErrorImagen = (file: any) => {
        setUrlImagen('');
        StatusAlertService.showError(
            `El tamaño del archivo debe ser menor a ${getImgMB()} mb...`
        );
    };
    const onTypeErrorImagen = (file: any) => {
        setUrlImagen('');
        StatusAlertService.showError(
            'El tipo de archivo que agrego no es valido...'
        );
    };

    const enterTexto = (target: any) => {
        if (target.key === 'Enter') {
            target.preventDefault();
        }
    };

    return (
        <>
            <div className="m-5">
                <Row className="mb-2">
                    <Col className="heading-1">Configuraciones</Col>
                </Row>
                <Row className="mt-3 agregar-portada">
                    <Col>
                        <Row className="titulo">
                            <Col className="heading-1">Imagen portada</Col>
                        </Row>
                        <Row className="mt-3">
                            <Col sm={3} className="minimocolumna">
                            </Col>
                            <Col sm={6} className="minimocolumna">
                                <Form.Label className="textorojoprimary">
                                    Medidas recomendadas: 1000*1200 px
                                </Form.Label>
                                <FileUploader
                                    label="Seleccione o arrastre imagen"
                                    hoverTitle="Suelte aqui!"
                                    maxSize={getImgMB()}
                                    children={
                                        <div className="adjuntar-imagenportada">
                                            {urlImagen != '' ? (
                                                <img src={urlImagen} />
                                            ) : (
                                                <div className="info-adjuntarportada">
                                                    <span className="titulo">{tituloAdjunto}</span>
                                                </div>
                                            )}
                                        </div>
                                    }
                                    handleChange={handleChangeImagen}
                                    onTypeError={onTypeErrorImagen}
                                    onSizeError={onSizeErrorImagen}
                                    name="file"
                                    types={fileTypes}
                                />
                            </Col>
                        </Row>
                        <div className="d-flex flex-row-reverse bd-highlight mt-3">
                            <Button
                                variant="primary"
                                className="float-end"
                                onClick={() => guardarEnlace()}
                            >
                                Guardar
                            </Button>
                            <Button
                                variant="secondary"
                                className="float-end me-3"
                                onClick={() => navigate(-1)}
                            >
                                Cancelar
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};
